import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@core/auth/authentication.service';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { HeaderPageSignalDataService } from '../header-page-signal-data.service';
import { RoleEnum } from '@core/models/role';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss']
})
export class SubHeaderComponent implements OnInit {

  mensagemSaudacao: string | undefined;
  size: NzButtonSize = 'large';

  constructor(
    private authenticationService: AuthenticationService,
    public headerPageSignalDataService: HeaderPageSignalDataService
  ) { }

  ngOnInit() {
    this.carregarDados();
    this.mensagemSaudacao = this.mensagemSaudacaoUsuario();
  }

  carregarDados() {
    if (this.authenticationService.currentUserValue?.nome) {
      this.headerPageSignalDataService.updateNameUser(this.authenticationService.currentUserValue?.nome);
    }
    if (this.authenticationService.currentUserValue?.dataUltimoAcesso) {
      this.headerPageSignalDataService.updateLastAccess(this.authenticationService.currentUserValue?.dataUltimoAcesso);
    }
    // console.log(this.authenticationService.currentUserValue);
    if (this.authenticationService.currentUserValue?.perfil?.perfil) {
      this.headerPageSignalDataService.updateProfileUser(this.authenticationService.currentUserValue?.perfil?.perfil?.toLowerCase());
    }
  }

  mensagemSaudacaoUsuario() {
    const dataAtual = new Date();
    const horaAtual = dataAtual.getHours();

    if (horaAtual >= 5 && horaAtual < 12) {
      return 'Bom dia!';
    } else if (horaAtual >= 12 && horaAtual < 18) {
      return 'Boa tarde!';
    } else {
      return 'Boa noite!';
    }
  }



  isUser() {
    return this.authenticationService.currentUserValue?.perfil?.perfil === RoleEnum.UsuarioLeitura; //alterar para o perfil do usuário
  }

  isAdministrator() {
    return this.authenticationService.currentUserValue?.perfil?.perfil === RoleEnum.UsuarioLeitura ; //alterar para o perfil do usuário
  }
}
